import { GetterTree } from "vuex";
import { SystemState } from "./types";
import { RootState } from "../../types";

export const getters: GetterTree<SystemState, RootState> = {};
